export default __webpack_public_path__ + "static/media/innercharge.d4dd9c67.png";